import { subTitle1, bold, overline, button, black, blackMedium, blackOutline, centerAbs, secondary, secondaryOutline, columnCenter } from "../../../../../resources/styles";
import { makeStyle } from "../../../../../utils";

const styles = {};

styles['container'] = makeStyle({
    border: `1px solid ${blackOutline.color}`,
});

styles['image_container'] = makeStyle({
    width: '100%',
    height: 181,
    position: 'relative',
    background: '#F2F2F2',
});

styles['image'] = makeStyle({
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});

styles['icon'] = makeStyle([{ width: '20px', height: '20px' }, centerAbs, blackMedium]);

styles['change_image'] = makeStyle({
    position: 'absolute',
    bottom: 0,
    right: 0,
    padding: 12,
    cursor: 'pointer',
    ...blackMedium,
});

styles['name'] = makeStyle([subTitle1, bold, black]);

styles['status_label'] = makeStyle({
    ...overline,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    marginTop: 16,
    ...blackMedium,
});

styles['status_value'] = makeStyle([subTitle1, black]);

styles['view_button'] = makeStyle({
    borderRadius: 6,
    padding: 8,
    border: `1px solid ${secondaryOutline.color}`,
    ...button,
    ...secondary,
    textAlign: 'center'
});

styles['inactive_btn'] = makeStyle({
    ...blackMedium,
    border:`1px solid ${blackMedium.color}`
});

styles['view_btn_link'] = makeStyle({
    marginTop: 16,
    width: '100%',
    display:'inline-grid'
})

styles['add_container'] = makeStyle({
    ...columnCenter,
    justifyContent: 'center',
    textAlign: 'center',
    border: `1px dashed ${blackOutline.color}`,
    padding: '24px 32px'
}, null, null, { padding: '24px 16px' });

styles['add_property_wrapper'] = makeStyle({
    maxWidth: 'calc(100% - 32px)',
    marginTop: 34,
})

styles['add_property'] = makeStyle({
   width:'100%',
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    ...button,
});

styles['add_icon'] = makeStyle({
    marginRight: 10,
    height: 16, width: 16,
});

export default styles;